import {
  Autocomplete as MuiAutocomplete,
  AutocompleteProps as MuiAutocompleteProps,
  Popper,
  styled,
} from "@mui/material";
import { autocompleteClasses } from "@mui/material/Autocomplete";

import { brandColors } from "../../utils/brand-colors";

type AutocompleteProps<
  Value = any,
  Multiple extends boolean | undefined = boolean | undefined,
  DisableClearable extends boolean | undefined = boolean | undefined,
  FreeSolo extends boolean | undefined = boolean | undefined,
  ChipComponent extends React.ElementType<any> = React.ElementType<any>,
> = MuiAutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, ChipComponent>;

const StyledAutocomplete = styled(MuiAutocomplete)(({ theme }) => {
  return {
    backgroundColor:
      theme.palette.mode === "light" ? brandColors.pirateBlack : brandColors.ceasefireWhite,
    borderRadius: "6px",
    "& .MuiInputBase-input": {
      color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : brandColors.pirateBlack,
    },
    "& .MuiOutlinedInput-root": {
      fontSize: "14px",
      fontWeight: 600,
      padding: "4px 6px",
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.mode === "light" ? brandColors.ceasefireWhite : brandColors.pirateBlack,
    },
  };
});

const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.option}`]: {
    backgroundColor: theme.palette.background.paper,
  },

  [`&& .${autocompleteClasses.groupLabel}`]: {
    lineHeight: `${theme.spacing(5)}`,
  },
}));

export const NavAutocomplete: React.FC<AutocompleteProps> = (props) => {
  return <StyledAutocomplete PopperComponent={StyledPopper} {...props} />;
};

export default NavAutocomplete;
